"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var kendo_react_data_tools_1 = require("@progress/kendo-react-data-tools");
var React = require("react");
/** @hidden */
exports.GridDetailHierarchyCell = function (props) {
    var navigationAttributes = kendo_react_data_tools_1.useTableKeyboardNavigation(props.id);
    return (React.createElement("td", __assign({ className: "k-hierarchy-cell" }, navigationAttributes)));
};
//# sourceMappingURL=GridDetailHierarchyCell.js.map